import React from 'react';
import { useTranslation } from 'react-i18next';
import { Notification, NotificationStatus } from '@cp-shared-19/frontend-ui';
import { FetchContractError } from 'cpes-common';
import { WithDefaultCpIntegrationErrors } from '@cp-shared-19/common-utilities';

export const NotificationForSmeContractsFetch: React.FC<{
    fetchContractError: WithDefaultCpIntegrationErrors<FetchContractError>;
}> = ({ fetchContractError }) => {
    const { t } = useTranslation('financial-details');

    switch (fetchContractError) {
        case 'CUSTOMER_NOT_FOUND': {
            return (
                <Notification
                    status={NotificationStatus.error}
                    headline={t('ibanSection.editView.smeContractsView.notification.customerNotFound.headline')}
                    testId={'editStatus'}
                >
                    {t('ibanSection.editView.smeContractsView.notification.customerNotFound.text')}
                </Notification>
            );
        }
        default: {
            return (
                <Notification
                    status={NotificationStatus.error}
                    headline={t('ibanSection.editView.smeContractsView.notification.apiNotReachable.headline')}
                    testId={'editStatus'}
                >
                    {t('ibanSection.editView.smeContractsView.notification.apiNotReachable.text')}
                </Notification>
            );
        }
    }
};
